import DSDialog from '../design-system/DSDialog';
import DSDialogContent from '../design-system/DSDialogContent';
import DSDialogActions from '../design-system/DSDialogActions';
import DSPrimaryButton from '../design-system/DSPrimaryButton';
import DSSecondaryButton from '../design-system/DSSecondaryButton';
import { DSTypography } from '../design-system/Typography';

const PAYMENT_URL = 'https://payment.klydoclock.com';
const REGISTER_URL = 'https://payment.klydoclock.com/password/reset';

type PaymentModalProps = {
  open: boolean;
  onClose: () => void;
};

const PaymentModal = ({ open, onClose }: PaymentModalProps) => {
  const handleLogin = () => {
    onClose();
    window.open(PAYMENT_URL, '_blank', 'noopener,noreferrer');
  };

  const handleRegister = () => {
    onClose();
    window.open(REGISTER_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <DSDialog maxWidth="md" open={open} onClose={onClose}>
      <DSDialogContent>
        <DSTypography variant="body2" color="text.primary">
          Please use the same email address as your Klydostudio account.
        </DSTypography>
      </DSDialogContent>
      <DSDialogActions sx={{ justifyContent: 'center' }}>
        <DSPrimaryButton onClick={handleRegister}>Register</DSPrimaryButton>
        <DSSecondaryButton variant="contained" onClick={handleLogin}>
          Login
        </DSSecondaryButton>
      </DSDialogActions>
    </DSDialog>
  );
};

export default PaymentModal;
